import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import { useNavigate, redirect } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import AvpSaveFooter from "../shared/footer/AvpSaveFooter";
import BreadCrumb from "../shared/header/BreadCrumb";
import {
  userIsLogged,
  getRoute,
  apiPostAvpArcoAdd,
  apiGetAvpAssistenteById,
  apiGetAvpGrafo,
} from "../shared/manager/api_manager";
import { useLingueStore } from "../sistema/storeLingua";

import { useEffectOnce } from "../shared/manager/use_effect_once";
import { getValueByQueryString } from "../shared/manager/util";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useGraphStore } from "./test-graph/store";
export default function NewGestioneArcoScreen() {
  const navigate = useNavigate();

  const { selectedNode, avp, nodes, aggiornaAvp, selectedLingua } =
    useGraphStore((state) => state);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  let breadCrumb = [
    { title: selectedLinguaTesto?.NewGestioneArcoBreadcrumb1, link: "/avp" },
    { title: selectedLinguaTesto?.NewGestioneArcoBreadcrumb2, link: null },
    { title: selectedLinguaTesto?.NewGestioneArcoBreadcrumb3, link: null },
    { title: selectedLinguaTesto?.NewGestioneArcoBreadcrumb4, link: null },
  ];

  const [currentBreadCrumb, setCurrentBreadCrumb] = useState(breadCrumb);
  //   const [selectedNode, setSelectedNode] = useState(null);
  const [selectedArc, setSelectedArc] = useState(null);

  //FORM
  const [formNodoEndStatus, setFormNodoEndStatus] = useState("");
  const [formTestoStatus, setFormTestoStatus] = useState("");
  const idArco = getValueByQueryString("idarco");

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      if (!selectedNode) {
        const idAvp = getValueByQueryString("idavp");
        navigate("/avp/grafo/" + idAvp);
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    loadAvp();
  }

  function loadAvp() {
    const url = window.location.pathname;
    const idAvp = getValueByQueryString("idavp");

    if (idAvp != null && idAvp != "") {
      apiGetAvpAssistenteById(idAvp, avpCallback);
    }
  }

  function avpCallback(response) {
    if (response != null && response.status >= 200 && response.status < 400) {
      onLoad(response.data);
    }
  }

  function onLoad(pAvp) {
    const idNodo = selectedNode.idNodo;
    let arco = selectedNode.archi.find((a) => String(a.idArco) === idArco);

    if (arco == null) {
      //new
      arco = {
        formato: "",
        idLingua:
          pAvp.lingue != null && pAvp.lingue.length > 0
            ? pAvp.lingue[0].idLingua
            : null,
        idNodoEnd: null,
        idNodoStart: selectedNode.idNodo,
        ordine: 1,
        testo: "",
      };
      breadCrumb[3].title = "Nuovo arco";
    } else {
      breadCrumb[3].title = "Arco " + arco.testo;
    }
    breadCrumb[2].link = "/avp/grafo/" + pAvp.idAvp + "?idnodo=" + idNodo;

    setCurrentBreadCrumb(breadCrumb);
    setSelectedArc(arco);
  }

  function FindDistance(idNodoEnd) {
    const nodeStart = nodes.find((n) => n.id === String(selectedNode.idNodo));
    let nodeEnd = nodes.find((n) => n.id === String(idNodoEnd));
    return nodeEnd.depth - nodeStart.depth;
  }
  function validateForm() {
    console.log("validateForm");
    let valid = true;
    const idNodoEnd = selectedArc.idNodoEnd;
    const testo = selectedArc.testo;

    if (testo == null || testo == "") {
      valid = false;
      setFormTestoStatus(" notvalid");
    } else {
      setFormTestoStatus("");
    }

    if (idNodoEnd == null || idNodoEnd == "") {
      valid = false;
      setFormNodoEndStatus(" notvalid");
    } else {
      setFormNodoEndStatus("");
    }

    return valid;
  }

  function saveArc() {
    apiPostAvpArcoAdd(selectedArc, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        navigate("/avp/grafo/" + avp.idAvp);
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  }

  function footerCancelCallback() {
    console.log("cancel");
    aggiornaAvp(avp.idAvp);

    // redirect("/avp/grafo/" + avp.idAvp);
    // const idLingua = getValueByQueryString("idlingua");
    navigate(
      "/avp/grafo/" +
        avp.idAvp +
        "?idnodo=" +
        selectedNode.idNodo +
        "&idlingua=" +
        selectedLingua.idLingua
    );
  }

  function footerSaveCallback() {
    console.log("save");

    if (validateForm()) {
      const idNodoEnd = selectedArc.idNodoEnd;
      const testo = selectedArc.testo;

      selectedArc.testo = testo;
      selectedArc.idNodoEnd = idNodoEnd;

      saveArc();
    }
  }
  function onChangeValueCheckbox(event, field) {
    if (field === "nonAttivo") {
      setSelectedArc({
        ...selectedArc,
        [field]: event.target.checked,
        idNodoEnd: "",
      });
    }

    setSelectedArc({ ...selectedArc, [field]: event.target.checked });
  }

  function onChange(e, field) {
    if (field === "idNodoEnd" && !selectedArc.terminaSessione) {
      const distance = FindDistance(e.target.value);

      setSelectedArc({
        ...selectedArc,
        [field]: e.target.value,
        formato: distance < 0 ? "back" : "",
      });
    } else {
      setSelectedArc({ ...selectedArc, [field]: e.target.value });
    }
    // setSelectedArc({...selectedArc,idNodoEnd:e.target.value})
  }
  // function onChangeTesto(e)
  // {
  //   setSelectedArc({...selectedArc,[]:e.target.value})
  //   // setSelectedArc({...selectedArc,testo:e.target.value})
  // }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#gestionearco"} />
      <div id="avp-cms-screen-container">
        <Collapse in={alertSuccessOpen}>
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.NewGestioneArcoAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.NewGestioneArcoAlertError}
          </Alert>
        </Collapse>
        <div>
          {/* {JSON.stringify(
            nodes.find((e) => e.idNodo == 713),
            null,
            2
          )} */}
          {/* {JSON.stringify(nodes[0], 2, 2)} */}
        </div>
        <div className="avp-cms-screen-content ">
          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-gestioneavp-nodearcs-section-title">
              {selectedLinguaTesto?.NewGestioneArcoTitle}
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-nodostart" className="required">
                {selectedLinguaTesto?.NewGestioneArcoFormStartNode}
              </label>
              <br />
              <input
                id="avp-form-nodostart"
                type="text"
                value={selectedNode != null ? selectedNode.descNodo : ""}
                disabled={true}
              />
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-nodoend" className="required">
                {selectedLinguaTesto?.NewGestioneArcoFormEndNode}
              </label>
              <br />

              {selectedArc?.idNodoEnd != null &&
              avp != undefined &&
              avp.nodi != undefined &&
              idArco ? (
                <input
                  id="avp-form-nodostart"
                  type="text"
                  value={
                    selectedArc != null
                      ? avp.nodi.find((e) => e.idNodo == selectedArc.idNodoEnd)
                          .descNodo
                      : ""
                  }
                  disabled={true}
                />
              ) : (
                <select
                  onChange={(e) => onChange(e, "idNodoEnd")}
                  id="avp-form-nodoend"
                  disabled={selectedArc != null && selectedArc.nonAttivo}
                  value={selectedArc != null ? selectedArc.idNodoEnd : ""}
                >
                  <option></option>
                  {nodes != null &&
                  avp != null &&
                  avp.nodi != null &&
                  avp.nodi.length > 0 ? (
                    nodes.map((item, i) => {
                      if (
                        selectedNode != null &&
                        item.idNodo != selectedNode.idNodo &&
                        item.nodoStart != true
                      ) {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.data.label}
                          </option>
                        );
                      } else {
                        return "";
                      }
                    })
                  ) : (
                    <option></option>
                  )}
                </select>
              )}
              {/* <select
                onChange={(e) => onChange(e, "idNodoEnd")}
                id="avp-form-nodoend"
                disabled={selectedArc != null && selectedArc.nonAttivo}
                value={selectedArc != null ? selectedArc.idNodoEnd : ""}
              >
                <option></option>
                {avp != null && avp.nodi != null && avp.nodi.length > 0 ? (
                  avp.nodi.map((item, i) => {
                    if (
                      selectedNode != null &&
                      item.idNodo != selectedNode.idNodo &&
                      item.nodoStart != true
                    ) {
                      return (
                        <option key={item.idNodo} value={item.idNodo}>
                          {item.descNodo}
                        </option>
                      );
                    } else {
                      return "";
                    }
                  })
                ) : (
                  <option></option>
                )}
              </select> */}
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div
              className="avp-cms-screen-content-column"
              style={{ width: "50%" }}
            >
              <label htmlFor="avp-form-text" className="required">
                {selectedLinguaTesto?.NewGestioneArcoTextArc}
              </label>
              <br />
              <input
                onChange={(e) => onChange(e, "testo")}
                id="avp-form-text"
                className={formTestoStatus}
                style={{ maxWidth: "none" }}
                type="text"
                defaultValue={selectedArc != null ? selectedArc.testo : ""}
              />
              <input
                id="avp-form-nonAttivo"
                type="checkbox"
                onChange={(event) => onChangeValueCheckbox(event, "nonAttivo")}
                checked={
                  selectedArc != null && selectedArc.nonAttivo ? "checked" : ""
                }
              />
              <label htmlFor="avp-form-nonAttivo">
                {selectedLinguaTesto?.NewGestioneArcoFormCheckboxNotActive}
              </label>
              <input
                id="avp-form-resetSession"
                type="checkbox"
                onChange={(event) =>
                  onChangeValueCheckbox(event, "terminaSessione")
                }
                checked={
                  selectedArc != null && selectedArc.terminaSessione
                    ? "checked"
                    : ""
                }
              />
              <label htmlFor="avp-form-resetSession">
                {selectedLinguaTesto?.NewGestioneArcoCheckboxResetSession}
              </label>
              <br />

              <input
                id="avp-form-skip"
                type="checkbox"
                onChange={(event) =>
                  onChangeValueCheckbox(event, "skipToNextNode")
                }
                checked={
                  selectedArc != null && selectedArc.skipToNextNode
                    ? "checked"
                    : ""
                }
              />
              <label htmlFor="avp-form-skip">
                {selectedLinguaTesto?.ANewGestioneArcoCheckboxSkipToNextNode}
              </label>
            </div>
          </div>
        </div>
      </div>
      <AvpSaveFooter
        saveCallback={footerSaveCallback}
        cancelCallback={footerCancelCallback}
      />
    </div>
  );
}
